import type { ChangeEvent } from 'react';
import './AuthFormInput.css';

interface AuthFormInputProps {
  id: string;
  name: string;
  type?: string;
  value: string;
  placeholder: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  required?: boolean;
  minLength?: number;
  autoComplete?: string;
}

export function AuthFormInput({
  id,
  name,
  type = 'text',
  value,
  placeholder,
  onChange,
  disabled = false,
  required = false,
  minLength,
  autoComplete,
}: AuthFormInputProps) {
  return (
    <input
      className="auth-form-input"
      type={type}
      id={id}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      required={required}
      minLength={minLength}
      autoComplete={autoComplete}
    />
  );
}
